import { registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { poolEnrollmentsDataProvider } from './dataProvider';

export function initSocialTradingPoolEnrollmentsDataProvider() {
  registerModuleDataProvider(Resources.socialTradingPoolEnrollments, poolEnrollmentsDataProvider);
}

initSocialTradingPoolEnrollmentsDataProvider();
